// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._financeDrawer_wcfnr_1 {
  /* Position */
  --pa-finance-drawer-close-button-right-inner: var(--pa-finance-drawer-close-button-right, -8px);
  --pa-finance-drawer-close-button-top-inner: var(--pa-finance-drawer-close-button-top, -8px);
  /* End Position */
  /* Typography */
  --pa-finance-drawer-title-size-xl-xxl-inner: var(--pa-finance-drawer-title-size-xl-xxl, 36px);
  --pa-finance-drawer-title-size-lg-inner: var(--pa-finance-drawer-title-size-lg, 32px);
  --pa-finance-drawer-title-size-xxs-md-inner: var(--pa-finance-drawer-title-size-xxs-md, 28px);
  --pa-finance-drawer-title-line-height-inner: var(--pa-finance-drawer-title-line-height, 1);
  --pa-finance-drawer-title-font-weight-inner: var(
    --pa-finance-drawer-title-font-weight,
    var(--perxis-auto-root-typography-h2-font-weight-inner)
  );
  --pa-finance-drawer-title-text-transform-inner: var(
    --pa-finance-drawer-title-text-transform,
    var(--perxis-auto-root-typography-h2-text-transform-inner)
  );
  /* End Typography */
  /* Color */
  --pa-finance-drawer-close-button-color-inner: var(
    --pa-finance-drawer-close-button-color,
    --perxis-auto-root-fourth-color-inner
  );
  --pa-finance-drawer-title-color-inner: var(
    --pa-finance-drawer-title-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Color */
  /* Drawer */
  --perxis-auto-drawer-width-sm: 100%;
  /* End Drawer */
}
._financeDrawer__inner_wcfnr_34 {
  flex-flow: column;
  min-height: 100%;
}
._financeDrawer__title_wcfnr_38 {
  --perxis-auto-typography-color-darkest: var(--pa-finance-drawer-title-color-inner);
  --perxis-auto-typography-h2-font-size-xxl: var(--pa-finance-drawer-title-size-xl-xxl-inner);
  --perxis-auto-typography-h2-font-size-xl: var(--pa-finance-drawer-title-size-xl-xxl-inner);
  --perxis-auto-typography-h2-font-size-lg: var(--pa-finance-drawer-title-size-lg-inner);
  --perxis-auto-typography-h2-font-size-md: var(--pa-finance-drawer-title-size-xxs-md-inner);
  --perxis-auto-typography-h2-font-size-sm: var(--pa-finance-drawer-title-size-xxs-md-inner);
  --perxis-auto-typography-h2-font-size-xs: var(--pa-finance-drawer-title-size-xxs-md-inner);
  --perxis-auto-typography-h2-font-size-xxs: var(--pa-finance-drawer-title-size-xxs-md-inner);
  --perxis-auto-typography-h2-font-weight: var(--pa-finance-drawer-title-font-weight-inner);
  --perxis-auto-typography-h2-text-transform: var(--pa-finance-drawer-title-text-transform-inner);
  bottom: 0;
  margin: 0;
  --perxis-auto-typography-h2-line-height-xxs: var(--pa-finance-drawer-title-line-height-inner);
  --perxis-auto-typography-h2-line-height-xs: var(--pa-finance-drawer-title-line-height-inner);
  --perxis-auto-typography-h2-line-height-sm: var(--pa-finance-drawer-title-line-height-inner);
  --perxis-auto-typography-h2-line-height-md: var(--pa-finance-drawer-title-line-height-inner);
  --perxis-auto-typography-h2-line-height-lg: var(--pa-finance-drawer-title-line-height-inner);
  --perxis-auto-typography-h2-line-height-xl: var(--pa-finance-drawer-title-line-height-inner);
  --perxis-auto-typography-h2-line-height-xxl: var(--pa-finance-drawer-title-line-height-inner);
}
._financeDrawer__closeButton_wcfnr_59 {
  position: absolute;
  z-index: 1000;
  top: var(--pa-finance-drawer-close-button-top-inner);
  right: var(--pa-finance-drawer-close-button-right-inner);
  --perxis-auto-button-text-color: var(--pa-finance-drawer-close-button-color-inner);
}
._financeDrawer__loader_wcfnr_66 {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
